import React from 'react';
import { IconButton, Stack } from '@fluentui/react';
import {
    bannerStyle,
    headerStyle,
    dismissButtonStyle,
    bannerWarningStyle,
    iconColor,
    bannerMessageStyle,
    bannerDismissOuterStyle
} from './styles/GroupCall.styles';

export interface BannerProps {
    dismissBanner(): void;
    bannerMessages: {
        Header: string;
        Message: string;
        LinkText: string;
    };
    timerPopup(): void;
    showAlertBanner: boolean;
    isMobile: boolean;
}


export default (props: BannerProps): JSX.Element => {
    return (
        <>
            <div className="row">
                <div id="bannerDiv" style={{ display: 'none', position: 'relative' }} >
                    <Stack.Item>
                        <div className={bannerStyle} id="banner">
                            <div className={bannerWarningStyle} style={{ marginLeft: props.isMobile ? '-23%' : '8%' }}>
                                <IconButton
                                    iconProps={{ iconName: 'Warningsolid' }}
                                    className={iconColor}
                                    title="Warning"
                                    ariaLabel="Warning"

                                />
                            </div>
                            <div className={headerStyle}>{props.bannerMessages.Header}</div> &nbsp;
                            <div className={bannerMessageStyle} style={{ width: props.isMobile ? '55%' : '40%' }}>{props.bannerMessages.Message}</div>
                            <div className={bannerDismissOuterStyle}>
                                <button onClick={props.dismissBanner} className={dismissButtonStyle}>
                                    Dismiss
                                </button>
                            </div>
                        </div>
                    </Stack.Item>
                </div>
            </div>
            <div className="row">
                {props.showAlertBanner && uRole == "Interviewer" && (
                    <div id="timeRemindingDiv" style={{ position: 'relative' }} >
                        <Stack.Item>
                            <div className={bannerStyle} style={{ background: "red" }}>
                                <div className={bannerWarningStyle} style={{ marginLeft: props.isMobile ? '0px' : '8%' }}>
                                    <IconButton
                                        iconProps={{ iconName: 'Warningsolid' }}
                                        className={iconColor}
                                        title="Warning"
                                        ariaLabel="Warning"
                                    />
                                </div>
                                <div className={bannerMessageStyle} style={{ width: props.isMobile ? '85%' : '40%' }}>
                                    {props.isMobile ? (
                                        <>Interview will end in 1 minute.</>
                                    ) : (
                                        <>This interview will end automatically in 1 minute, to continue please update timer.</>
                                    )}

                                </div>
                                <div className={bannerDismissOuterStyle}>
                                    <button onClick={props.timerPopup} className={dismissButtonStyle} style={{
                                        background: "#fff",
                                        color: "#000",
                                        position: "relative"
                                    }}>
                                        Add Time
                                    </button>
                                </div>
                            </div>
                        </Stack.Item>
                    </div>
                )}
            </div>
        </>
    );
};

//export default (props: BannerProps): JSX.Element => {
//  return (
//      <div id="bannerDiv" style={{display:'none',position:'relative'}} >
//      <Stack.Item>
//        <div className={bannerStyle} id="banner">
//          <div className={bannerWarningStyle}>
//            <IconButton
//              iconProps={{ iconName: 'Warningsolid' }}
//              className={iconColor}
//              title="Warning"
//              ariaLabel="Warning"
//            />
//          </div>
//          <div className={headerStyle}>{props.bannerMessages.Header}</div> &nbsp;
//          <div className={bannerMessageStyle}>{props.bannerMessages.Message}</div>
//          <div className={bannerDismissOuterStyle}>
//            <button onClick={props.dismissBanner} className={dismissButtonStyle}>
//              Dismiss
//            </button>
//          </div>
//        </div>
//      </Stack.Item>
//    </div>
//  );
//};
